
import { useRef } from "react";
import Navbar from "./components/Navabr";
import Hero from "./Pages/Hero";
import About from "./Pages/About";
import Programs from "./Pages/Programs";
import Faculty from "./Pages/Faculty";
import Contact from "./Pages/Contact";
import Footer from "./Pages/Footer";


function App() {
  const heroRef = useRef(null);
  const aboutRef = useRef(null);
  const programsRef = useRef(null);
  const facultyRef = useRef(null);
  const contactRef = useRef(null);

  

  const sectionStyle = {
    scrollMarginTop: "88px",
  };

  return (
    <>
      <Navbar
        heroRef={heroRef}
        aboutRef={aboutRef}
        programsRef={programsRef}
        facultyRef={facultyRef}
        contactRef={contactRef}
       
      />

      <div ref={heroRef}>
          <Hero contactRef={contactRef} />
      </div>

      <div ref={aboutRef} style={sectionStyle}>
        <About />
      </div>

      <div ref={programsRef} style={sectionStyle}>
        <Programs />
      </div>

      <div ref={facultyRef} style={sectionStyle}>
        <Faculty />
      </div>

     

      <div ref={contactRef} style={sectionStyle}>
        <Contact />
      </div>

   

      <Footer />
    </>
  );
}

export default App;
